<div class="datatable-page-header">
  <h1 trans>
    <span trans>Link Overlays</span>
    <info-popover>
      <span trans
        >Display fully customizable overlay with a message and call-to-action button over
        destination website.</span
      >
    </info-popover>
  </h1>

  <div class="header">
    <datatable-filters pluralName="overlays" [filters]="filters"></datatable-filters>
    <div class="action-buttons">
      <permission-aware-button permission="link_overlays.create">
        <button mat-raised-button color="accent" routerLink="new" class="button-with-icon">
          <mat-icon svgIcon="add"></mat-icon>
          <span trans>Add New Overlay</span>
        </button>
      </permission-aware-button>
    </div>
  </div>
</div>

<div class="datatable responsive-table">
  <mat-progress-bar
    class="loading-bar"
    mode="indeterminate"
    color="accent"
    *ngIf="datatable.paginator && datatable.paginator.loading$ | async"
  ></mat-progress-bar>
  <table class="material-table">
    <thead>
      <tr>
        <th table-header-checkbox></th>
        <th table-sort-header trans>Name</th>
        <th *ngIf="showUserColumn()" trans>Owner</th>
        <th table-sort-header="clicks_count">Message</th>
        <th trans>Action</th>
        <th trans>Color</th>
        <th trans>Last Updated</th>
        <th></th>
      </tr>
      <tr *ngIf="datatable.selectedRows$.value.length as selectedCount">
        <th colspan="8">
          <div
            class="bulk-actions-title"
            [transValues]="{count: selectedCount, resource: 'overlay(s)'}"
            trans
          >
            :count :resource selected:
          </div>
          <div class="bulk-actions">
            <permission-aware-button permission="link_overlays.delete">
              <button
                type="button"
                mat-raised-button
                color="warn"
                (click)="maybeDeleteSelectedOverlays()"
                trans
              >
                Delete
              </button>
            </permission-aware-button>
          </div>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let overlay of overlays$ | async">
        <td [table-body-checkbox]="overlay.id"></td>
        <td data-label="Name">{{ overlay.name }}</td>
        <td data-label="Owner" *ngIf="showUserColumn()">
          <user-column [user]="overlay.user"></user-column>
        </td>
        <td data-label="Message">{{ overlay.message }}</td>
        <td data-label="Action">{{ overlay.btn_text }}</td>
        <td data-label="Color">
          <mat-icon
            svgIcon="drop-custom"
            class="color-icon"
            [style.color]="overlay.colors['bg-color']"
          ></mat-icon>
        </td>
        <td data-label="Last Updated">{{ overlay.updated_at | formattedDate }}</td>
        <td class="edit-column">
          <permission-aware-button
            permission="link_overlays.update"
            [userOwnsResource]="currentUser.get('id') === overlay.user_id"
          >
            <button
              mat-icon-button
              [routerLink]="['edit', overlay.id]"
              [matTooltip]="'Edit overlay' | trans"
            >
              <mat-icon svgIcon="edit"></mat-icon>
            </button>
          </permission-aware-button>
          <permission-aware-button permission="link_overlays.delete" class="visible-on-mobile">
            <button
              type="button"
              mat-icon-button
              (click)="maybeDeleteSelectedOverlays([overlay.id])"
              trans
            >
              <mat-icon svgIcon="delete"></mat-icon>
            </button>
          </permission-aware-button>
        </td>
      </tr>
    </tbody>
  </table>
  <no-results-message svgImage="popular.svg" *ngIf="datatable.paginator.noResults$ | async">
    <span primary-text trans>No link overlays have been created yet</span>
  </no-results-message>
  <datatable-footer></datatable-footer>
</div>
